import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchSidebarProfileTitle = createAsyncThunk(
  'sidebar/fetchProfileTitle',
  async ({ email }, { signal, rejectWithValue }) => {
    try {
      const res = await fetch(`${API_URL}/api/SidebarProfileTitle?email=${encodeURIComponent(email)}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        signal,
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json?.message || 'Failed to fetch profile title');
      return json?.message ?? null;
    } catch (e) {
      if (e?.name === 'AbortError') throw e;
      console.error('sidebar/fetchProfileTitle failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch profile title');
    }
  }
);

export const fetchGraphMePhotoDataUrl = createAsyncThunk(
  'sidebar/fetchGraphMePhotoDataUrl',
  async ({ accessToken }, { signal, rejectWithValue }) => {
    try {
      const res = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
        headers: { Authorization: `Bearer ${accessToken}` },
        signal,
      });
      if (!res.ok) throw new Error(`Graph photo failed: HTTP ${res.status}`);
      const blob = await res.blob();
      const dataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      return dataUrl;
    } catch (e) {
      if (e?.name === 'AbortError') throw e;
      console.error('sidebar/fetchGraphMePhotoDataUrl failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch profile photo');
    }
  }
);

const slice = createSlice({
  name: 'sidebar',
  initialState: {
    profileTitle: null,
    profileTitleLoading: false,
    profileTitleError: null,
    photoDataUrl: null,
    photoLoading: false,
    photoError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSidebarProfileTitle.pending, (state) => {
        state.profileTitleLoading = true;
        state.profileTitleError = null;
      })
      .addCase(fetchSidebarProfileTitle.fulfilled, (state, action) => {
        state.profileTitleLoading = false;
        state.profileTitle = action.payload ?? null;
      })
      .addCase(fetchSidebarProfileTitle.rejected, (state, action) => {
        state.profileTitleLoading = false;
        if (action?.meta?.aborted || action?.error?.name === 'AbortError') return;
        state.profileTitleError = action.payload || action.error?.message || 'Failed to fetch profile title';
      })
      .addCase(fetchGraphMePhotoDataUrl.pending, (state) => {
        state.photoLoading = true;
        state.photoError = null;
      })
      .addCase(fetchGraphMePhotoDataUrl.fulfilled, (state, action) => {
        state.photoLoading = false;
        state.photoDataUrl = action.payload ?? null;
      })
      .addCase(fetchGraphMePhotoDataUrl.rejected, (state, action) => {
        state.photoLoading = false;
        if (action?.meta?.aborted || action?.error?.name === 'AbortError') return;
        state.photoError = action.payload || action.error?.message || 'Failed to fetch profile photo';
      });
  },
});

export default slice.reducer;


